import { useEffect, useRef, useState } from 'react';
const usePolling = ({ interval = 5000, firstRunDelay = 0, validator, query, maxAttempts, onPollFailure, onComplete, enabled = true, }) => {
    const [isPolling, setIsPolling] = useState(false);
    const [data, setData] = useState(undefined);
    const [error, setError] = useState(undefined);
    const [pollCount, setPollCount] = useState(0);
    const timerRef = useRef(null);
    const controllerRef = useRef(new AbortController());
    const isFirstRun = useRef(true);
    const cleanup = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
    };
    const executeQuery = () => {
        if (!enabled)
            return;
        if (maxAttempts !== undefined && pollCount >= maxAttempts) {
            setIsPolling(false);
            onPollFailure?.();
            return;
        }
        setIsPolling(true);
        controllerRef.current = new AbortController();
        query(controllerRef.current.signal)
            .then((result) => {
            if (validator?.(result)) {
                setIsPolling(false);
                setData(result);
                onComplete?.(result);
                cleanup();
            }
            else {
                setPollCount((prev) => prev + 1);
            }
        })
            .catch((err) => {
            setIsPolling(false);
            setError(err);
            cleanup();
        });
    };
    useEffect(() => {
        if (!enabled) {
            cleanup();
            return;
        }
        setIsPolling(true);
        timerRef.current = setTimeout(() => {
            executeQuery();
        }, isFirstRun.current ? firstRunDelay : interval);
        isFirstRun.current = false;
        return cleanup;
    }, [pollCount, enabled]);
    return {
        isPolling,
        isError: !!error,
        error,
        data,
    };
};
export default usePolling;
